var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7007 0.410594L13.7008 0.41001H13.6899H1.49997V0.409995L1.49827 0.410024C1.37398 0.412132 1.25257 0.448274 1.14736 0.514535C1.04218 0.580778 0.957104 0.674592 0.901493 0.785815C0.845897 0.897006 0.821825 1.02133 0.831941 1.14525C0.842044 1.26901 0.885873 1.38764 0.958584 1.48825C0.958683 1.48839 0.958781 1.48852 0.95888 1.48866L5.4184 7.77784L5.41837 7.77786L5.41997 7.78C5.56926 7.97906 5.64997 8.22118 5.64997 8.47V13.6V13.6C5.65004 13.7798 5.72123 13.9523 5.84812 14.0797C5.94005 14.1769 6.06017 14.2428 6.19154 14.2683C6.3225 14.2936 6.45806 14.2774 6.57932 14.2219L9.08276 13.2246C9.21557 13.1844 9.3314 13.1015 9.41229 12.9887C9.4937 12.8751 9.53511 12.7377 9.5299 12.5981V8.51001C9.5299 8.26118 9.61061 8.01907 9.7599 7.82001L9.75993 7.82003L9.76141 7.81794L14.2314 1.52793L14.2316 1.52805L14.2349 1.52259C14.3014 1.41515 14.3365 1.29133 14.3365 1.16501C14.3365 1.04162 14.303 0.920618 14.2395 0.814933C14.1949 0.706834 14.1224 0.612415 14.0291 0.54148C13.9336 0.468786 13.82 0.423549 13.7007 0.410594ZM1.92382 1.22H13.2777L9.04866 7.25161C8.78659 7.60758 8.64364 8.03718 8.63996 8.47918V8.48001V12.4413L6.54992 13.2445V8.39001V8.38987C6.54929 7.94877 6.40977 7.51906 6.15117 7.16171C6.15109 7.1616 6.151 7.16148 6.15092 7.16136L1.92382 1.22Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.b2f3a7d985fc55d6bbfad718bb0e91ca.svg";
export { ForwardRef as ReactComponent };